module.exports = __webpack_public_path__ + "img/pg4-article-text2.de159e08.png";